import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import Navbar from './components/feature/Navbar';
import Footer from './components/feature/Footer';
import ScrollToTop from './components/feature/ScrollToTop';
import { Toaster } from 'sonner';

function AppContent() {
  const location = useLocation();
  
  // Pages d'établissements qui ne doivent pas afficher le Navbar et Footer du portail
  const etablissementPages = [
    '/lycee-francais',
    '/lycee-ivoirien',
    '/institut',
    '/maternelle-primaire'
  ];
  
  // Vérifier si on est sur une page d'établissement
  const isEtablissementPage = etablissementPages.some(path => location.pathname.startsWith(path));
  
  return (
    <>
      {!isEtablissementPage && <Navbar />}
      <AppRoutes />
      {!isEtablissementPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Toaster />
      <ScrollToTop />
      <div className="overflow-x-hidden">
      <AppContent />
      </div>
    </BrowserRouter>
  );
}

export default App;
